'use strict';

var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
var COLOR = 'tealA700';

function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
}

Date.prototype.Format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

Date.prototype.toLocal = function (date) {
    let localDate = date.getTime();
    let localOffset = date.getTimezoneOffset() * 60 * 1000;
    return new Date(localDate + localOffset);
}

export function getQueryStringByName(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    let context = "";
    if (r != null)
        context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

export function parse(dateString, pattern) {
    let matchs1 = pattern.match(SIGN_REGEXP);
    let matchs2 = dateString.match(/(\d)+/g);
    if (matchs1.length == matchs2.length) {
        let _date = new Date(1970, 0, 1);
        for (let i = 0; i < matchs1.length; i++) {
            let _int = parseInt(matchs2[i]);
            let sign = matchs1[i];
            switch (sign.charAt(0)) {
                case 'y':
                    _date.setFullYear(_int);
                    break;
                case 'M':
                    _date.setMonth(_int - 1);
                    break;
                case 'd':
                    _date.setDate(_int);
                    break;
                case 'h':
                    _date.setHours(_int);
                    break;
                case 'm':
                    _date.setMinutes(_int);
                    break;
                case 's':
                    _date.setSeconds(_int);
                    break;
            }
        }
        return _date;
    }
    return null;
}

export function fmtDate(date, pattern) {
    pattern = pattern || DEFAULT_PATTERN;
    return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
            case 'y':
                return padding(date.getFullYear(), $0.length);
            case 'M':
                return padding(date.getMonth() + 1, $0.length);
            case 'd':
                return padding(date.getDate(), $0.length);
            case 'w':
                return date.getDay() + 1;
            case 'h':
                return padding(date.getHours(), $0.length);
            case 'm':
                return padding(date.getMinutes(), $0.length);
            case 's':
                return padding(date.getSeconds(), $0.length);
        }
    });
}

export function formatDig(num) {
    return num > 9 ? '' + num : '0' + num;
}

export function formatDate(mill) {
    let y = new Date(mill);
    let raws = [
        y.getFullYear(),
        formatDig(y.getMonth() + 1),
        formatDig(y.getDate()),
        // y.getDay()||7
    ];
    let format = ['年', '月', '日'];
    return String.raw({raw: raws}, ...format);
}

export function* createWeeks(year) {
    const ONE_DAY = 24 * 3600 * 1000;
    let start = new Date(year, 0, 1),
        end = new Date(year, 11, 31);
    let firstDay = start.getDay() || 7,
        lastDay = end.getDay() || 7;
    let startTime = +start,
        endTime = startTime + (7 - firstDay) * ONE_DAY,
        _endTime = end - (7 - lastDay) * ONE_DAY;

    yield [startTime, endTime];
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
    while (endTime < _endTime) {
        yield [startTime, endTime];
        startTime = endTime + ONE_DAY;
        endTime = endTime + 7 * ONE_DAY;
    }
    yield [startTime, +end];
}
const year = new Date().getFullYear()
let yearOfAllWeeks = createWeeks(year)
export let weeksOfYear = []
for (let i of yearOfAllWeeks) {
    weeksOfYear.push(i)
}



// WEBPACK FOOTER //
// ./src/common/js/util.js